import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  LoadingPopUp,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../common-components";
import useWindowDimensions from "../../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
// import {
//   L12,
//   L13,
//   L14,
//   L16,
//   L18,
//   L21,
//   L24,
//   L25,
//   L26,
//   L27,
//   L28,
//   L29,
//   L30,
//   L31,
//   L34,
//   L35,
//   L37,
//   L38,
//   Lo1_Abv,
//   Lo4_Adv,
//   Lo8_Alv,
//   Lo9,
// } from "./pdf-display-components";
import {
  CommentPopup,
  F01_Doc,
  F02_Doc,
  F04_Doc,
  F05_Doc,
  F06_Doc,
  F07_Doc1,
  F07_Doc2,
  F08_Doc,
  F41_Doc,
  L08_Doc,
  L09_Doc,
  L12_Doc,
  L13_Doc,
  L14_Doc,
  L16_Doc,
  L18_Doc,
  L21_Doc,
  L24_Doc,
  L25_Doc,
  L26_Doc,
  L27_Doc,
  L28_Doc,
  L29_Doc,
  L30_Doc,
  L31_Doc,
  L34_Doc,
  L35_Doc,
  L37_Doc,
  L38_Doc,
  RequestPopUp,
} from "./components";
import L01_Doc from "./components/l01-doc/L01_Doc";
import L04_Doc from "./components/l04-doc/L04_Doc";

const TaskManager = ({
  display,
  onCloseClick,
  setSelectedTask,

  setMessage,
  setPopUpTitle,
  setToastPop,
  auth,
  companyInformation,
  setTasksArrayRefresh,
  tasksArrayRefresh,
}) => {
  const { width, height } = useWindowDimensions();
  const [selectedView, setSelectedView] = useState("requested by");
  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState(null);

  const [commentPopUp, setCommentPopUp] = useState(false);
  const [requestPopUp, setRequestPopUp] = useState(false);

  const [taskRefresh, setTaskRefresh] = useState(false);

  const [pdfDisplay, setPdfDisplay] = useState("none");

  const [addVehicle, setAddVehicle] = useState(false);

  const [foundVehicle, setFoundVehicle] = useState(null);

  // console.log("task type", display);
  const getTaskUserInfo = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/getAgencyCustomerInfo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: display.requestedByUserId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);
        setCustomerData(respnseData.customers);
        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");

        // setToastPop(true);
      } else {
        setLoading(false);
      }
      //  else {
      //   setLoading(false);
      //   setPopUpTitle("FAILED");
      //   setMessage("Unable to find customers, " + " " + respnseData.message);
      //   setToastPop(true);
      // }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      // setMessage(
      //   "Unable to login into account, please wait 5 mins then try again or contact support" +
      //     " " +
      //     err
      // );
      // setToastPop(true);
    }
  };

  const AcceptandAssignTask = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/changeAgencyTaskStatus",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            taskId: display._id,
            status: "Approved",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);

        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage("You have accepted the task");
        setSelectedTask(null);
        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to save, " + " " + respnseData.message);
        setToastPop(true);
      }
      //  else {

      // }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      setPopUpTitle("FAILED");
      setMessage(err);
      setToastPop(true);
    }
  };
  const DeclineTask = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/changeAgencyTaskStatus",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            taskId: display._id,
            status: "Declined",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);

        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage("You have declined the task");
        setSelectedTask(null);
        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to save, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      setPopUpTitle("FAILED");
      setMessage(err);
      setToastPop(true);
    }
  };

  const RequestTaskPayment = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/changeAgencyTaskStatus",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            taskId: display._id,
            status: "Payment Request",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);

        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage(
          "You have set task complete and your requesting payment from client."
        );
        setSelectedTask(null);
        setTasksArrayRefresh(tasksArrayRefresh ? true : false);
        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to save, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      setPopUpTitle("FAILED");
      setMessage(err);
      setToastPop(true);
    }
  };

  const PaymentRecieved = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/changeAgencyTaskStatus",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            taskId: display._id,
            status: "Paid",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);

        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage(
          "You have accepted the task has been paid for by the client."
        );
        setSelectedTask(null);
        setTasksArrayRefresh(tasksArrayRefresh ? true : false);
        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to save, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      setPopUpTitle("FAILED");
      setMessage(err);
      setToastPop(true);
    }
  };
  // console.log("display", display);
  useEffect(() => {
    getTaskUserInfo();
  }, [taskRefresh]);
  useEffect(() => {
    if (display) {
      getTaskUserInfo();
    } else {
      setCustomerData(null);
    }
  }, [display]);
  return (
    <div
      style={{
        backgroundColor: colors.white,
        height: display ? "100%" : 0,
        width: "100%",
        position: "absolute",
        top: 0,
        overflow: "hidden",
        alignItems: "center",
      }}
    >
      <div style={{ position: "absolute", top: 20, left: 20 }}>
        <BaseButtons
          label={"X"}
          borderRadius={8}
          width={40}
          backgroundColor={colors.secondaryDarkBlue}
          onClick={onCloseClick}
        />
      </div>
      <div
        style={{
          marginTop: 25,
          fontSize: 22,
          fontWeight: "bold",
          marginLeft: 80,
          display: "flex",
          width: "93%",
          alignItems: "center",
        }}
      >
        {display ? display.taskTitle.toLocaleUpperCase() : null}
        <div style={{ flex: 1 }} />
        {/* <BaseButtons
          label={"TASK DETAILS"}
          backgroundColor={
            selectedView === "details"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          padding={10}
          onClick={() => setSelectedView("details")}
        /> */}
        <BaseButtons
          label={"REQUESTED BY"}
          backgroundColor={
            selectedView === "requested by"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          padding={10}
          onClick={() => setSelectedView("requested by")}
        />
        <BaseButtons
          label={"VEHICLE"}
          backgroundColor={
            selectedView === "vehicle"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          padding={10}
          onClick={() => setSelectedView("vehicle")}
        />
        <BaseButtons
          label={"TIMELINE"}
          backgroundColor={
            selectedView === "timeline"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          padding={10}
          onClick={() => setSelectedView("timeline")}
        />
        <BaseButtons
          label={"TASK REQUESTS"}
          backgroundColor={
            selectedView === "requests"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          onClick={() => setSelectedView("requests")}
        />
        <BaseButtons
          label={"COMMENTS"}
          backgroundColor={
            selectedView === "comments"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          padding={10}
          onClick={() => setSelectedView("comments")}
        />
        <BaseButtons
          label={"FORMS"}
          backgroundColor={
            selectedView === "forms"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          padding={10}
          onClick={() => setSelectedView("forms")}
        />
        {/* <BaseButtons
          label={"VEHICLE DATA"}
          backgroundColor={
            selectedView === "vehicleData"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          padding={10}
          onClick={() => setSelectedView("vehicleData")}
        />
        <BaseButtons
          label={"CUSTOMER INFO"}
          backgroundColor={
            selectedView === "customerInfo"
              ? colors.secondaryDarkBlue
              : colors.primaryBlue
          }
          padding={10}
          onClick={() => setSelectedView("customerInfo")}
        /> */}

        <div style={{ textAlign: "right", marginLeft: 40 }}>
          <div style={{ fontSize: 10, opacity: 0.6, fontWeight: "bold" }}>
            STATUS
          </div>
          <div style={{ fontSize: 18 }}>
            {display ? display.taskStatus.toLocaleUpperCase() : null}
          </div>
        </div>
      </div>
      <div
        style={{
          flex: 1,
          marginTop: 4,
          height: "94%",
          backgroundColor: colors.secondaryDarkBlue,
          display: "flex",
        }}
      >
        {/* basic task info */}
        <div
          style={{
            backgroundColor: colors.white,
            flex: 0.35,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: height - 135,
          }}
        >
          <div style={{ width: "90%", marginTop: 20 }}>
            <div
              style={{
                fontSize: 12,
                fontWeight: "bold",
                opacity: 0.6,
                marginBottom: 5,
              }}
            >
              AGENCY ID
            </div>
            <div>{display ? display.agencyId.toLocaleUpperCase() : null}</div>
          </div>
          <div style={{ width: "90%", marginTop: 20 }}>
            <div
              style={{
                fontSize: 12,
                fontWeight: "bold",
                opacity: 0.6,
                marginBottom: 5,
              }}
            >
              AGENCY NAME
            </div>
            <div>{display ? display.agencyName : null}</div>
          </div>
          <div style={{ width: "90%", marginTop: 20 }}>
            <div
              style={{
                fontSize: 12,
                fontWeight: "bold",
                opacity: 0.6,
                marginBottom: 5,
              }}
            >
              TASK DETAILS
            </div>
            <div>{display ? display.taskDetails : null}</div>
          </div>

          <div style={{ width: "90%", marginTop: 20 }}>
            <div
              style={{
                fontSize: 12,
                fontWeight: "bold",
                opacity: 0.6,
                marginBottom: 5,
              }}
            >
              TASK INDENTIFIER
            </div>
            <div>{display ? display.taskIdentifier : null}</div>
          </div>
          <div style={{ width: "90%", marginTop: 20 }}>
            <div
              style={{
                fontSize: 12,
                fontWeight: "bold",
                opacity: 0.6,
                marginBottom: 5,
              }}
            >
              TASK TYPE
            </div>
            <div>{display ? display.taskType : null}</div>
          </div>

          <div style={{ width: "90%", marginTop: 20 }}>
            <div
              style={{
                fontSize: 12,
                fontWeight: "bold",
                opacity: 0.6,
                marginBottom: 5,
              }}
            >
              VEHICLE THAT NEEDS ACTION
            </div>
            <div>
              {display ? display.vehicleId.vehicleIndentificationNumber : null}
            </div>
          </div>
          <div style={{ flex: 1 }} />
          {display ? (
            display.taskStatus === "Requested" ? (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BaseButtons
                  label={"APPROVE"}
                  backgroundColor={colors.greenLight}
                  width={"50%"}
                  onClick={() => AcceptandAssignTask()}
                />
                <BaseButtons
                  label={"DECLINE"}
                  backgroundColor={colors.orangeDark}
                  width={"50%"}
                  onClick={() => DeclineTask()}
                />
              </div>
            ) : null
          ) : null}
          {display ? (
            display.taskStatus === "Paid" ? (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BaseButtons
                  label={"COMPLETE"}
                  backgroundColor={colors.greenLight}
                  width={"100%"}
                  // disabled={true}
                />
              </div>
            ) : display.taskStatus !== "Payment Request" ? (
              <BaseButtons
                label={"ADD NEW FINE"}
                backgroundColor={colors.greenLight}
                width={"100%"}
                onClick={() => setSelectedView("new Fine")}
                // disabled={true}
              />
            ) : null
          ) : null}
        </div>
        {/* data display */}
        {(pdfDisplay !== "none" && display.taskStatus === "Approved") ||
        selectedView === "forms" ? null : (
          <div
            style={{
              flex: 0.65,
              // borderStyle: "solid",
              // borderColor: colors.white,
              minHeight: height - 140,
              maxHeight: height - 140,
              overflowY: "scroll",
              overflowX: "hidden",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              alignItems:
                (commentPopUp && selectedView === "comments") ||
                (requestPopUp && selectedView === "requests")
                  ? "center"
                  : null,
            }}
          >
            <div
              style={{
                fontSize: 18,
                fontWeight: "bold",
                color: colors.white,
                marginTop: 20,
                marginLeft: 20,
              }}
            >
              {selectedView.toLocaleUpperCase()}
            </div>
            {selectedView === "requested by" ? (
              <>
                {/* // TITLE */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    TITLE:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.title : null}
                  </div>
                </div>
                {/* // name */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    NAME:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData
                      ? customerData.firstName + " " + customerData.lastName
                      : null}
                  </div>
                </div>

                {/* Cell number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    Cell Number:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.cellNumber : null}
                  </div>
                </div>

                {/* Email */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    Email:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.email : null}
                  </div>
                </div>

                {/* id number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    ID NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.idDoc : null}
                  </div>
                </div>

                {/* Address */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    ADDRESS:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.address : null}
                  </div>
                </div>
              </>
            ) : null}
            {selectedView === "vehicle" ? (
              <div style={{ position: "relative" }}>
                {/* // control number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    CONTROL NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.controlNumber : null}
                  </div>
                </div>
                {/* // document number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    DOCUMENT CODE:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.docCode : null}
                  </div>
                </div>
                {/* // issue number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    ISSUE NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.issueNumber : null}
                  </div>
                </div>
                {/* // date of issue */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    DATE OF ISSUE:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.dateOfIssue : null}
                  </div>
                </div>
                {/* // indentification number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    IDENTIFICATION NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.indentificationNumber : null}
                  </div>
                </div>
                {/* // register number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    REGISTER NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.registerNumber : null}
                  </div>
                </div>
                {/* // vehicle identifiction number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    VEHICLE IDENTIFICATION NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display
                      ? display.vehicleId.vehicleIndentificationNumber
                      : null}
                  </div>
                </div>
                {/* // engine number  */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    ENGINE NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.engineNUmber : null}
                  </div>
                </div>
                {/* // Make  */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    MAKE:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.make : null}
                  </div>
                </div>
                {/* // Make  */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    SERIES:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.series : null}
                  </div>
                </div>
                {/* //transaction number */}
                <div
                  style={{
                    position: "absolute",
                    top: -40,
                    right: 20,
                    textAlign: "right",
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    TRANSACTION NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {display ? display.vehicleId.transactionNr : null}
                  </div>
                </div>
                <div style={{ minHeight: 20 }} />
              </div>
            ) : null}
            {selectedView === "timeline" ? (
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {display
                  ? display.taskTimeline.map((item, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            width: "90%",
                            backgroundColor: colors.white,
                            borderRadius: 8,
                            // minHeight: 80,
                            marginTop: 20,
                            display: "flex",
                            padding: 15,
                            flexDirection: "column",
                            position: "relative",
                          }}
                        >
                          {/* date created */}
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                              }}
                            >
                              DATE CREATED
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {new Date(
                                item.taskTimelineItem.itemDateTime
                              ).toLocaleString()}
                            </div>
                          </div>
                          {/* action data */}
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              ACTION
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.taskTimelineItem.actionData}
                            </div>
                          </div>
                          {/* Comment data */}
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              COMMENT
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.taskTimelineItem.comment}
                            </div>
                          </div>
                          {/* User*/}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 10,
                              textAlign: "right",
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              User
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.taskTimelineItem.user}
                            </div>
                          </div>

                          {/* User*/}
                          <div
                            style={{
                              position: "absolute",
                              bottom: 10,
                              right: 10,
                              textAlign: "right",
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              AGENT
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.taskTimelineItem.agent}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}

                <div style={{ minHeight: 20 }} />
              </div>
            ) : null}

            {selectedView === "requests" ? (
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {display
                  ? display.taskRequests.map((item, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            width: "90%",
                            backgroundColor: colors.white,
                            borderRadius: 8,
                            // minHeight: 80,
                            marginTop: 20,
                            display: "flex",
                            padding: 15,
                            flexDirection: "column",
                            position: "relative",
                          }}
                        >
                          {/* date created */}
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                              }}
                            >
                              REQUEST DATE
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {new Date(
                                item.request.requestDateTime
                              ).toLocaleString()}
                            </div>
                          </div>
                          {/* action data */}
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              REQUEST
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.request.request}
                            </div>
                          </div>

                          {/* User*/}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 10,
                              textAlign: "right",
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              User
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.request.user}
                            </div>
                          </div>

                          {/* User*/}
                          <div
                            style={{
                              position: "absolute",
                              bottom: 10,
                              right: 10,
                              textAlign: "right",
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              AGENT
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.request.agent}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}

                <div style={{ minHeight: 20 }} />
              </div>
            ) : null}

            {selectedView === "comments" ? (
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {display
                  ? display.taskComments.map((item, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            width: "90%",
                            backgroundColor: colors.white,
                            borderRadius: 8,
                            // minHeight: 80,
                            marginTop: 20,
                            display: "flex",
                            padding: 15,
                            flexDirection: "column",
                            position: "relative",
                          }}
                        >
                          {/* date created */}
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                              }}
                            >
                              COMMENT DATE
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {new Date(
                                item.comment.commentDateTime
                              ).toLocaleString()}
                            </div>
                          </div>
                          {/* action data */}
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              COMMENT
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.comment.comment}
                            </div>
                          </div>

                          {/* User*/}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 10,
                              textAlign: "right",
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              User
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.comment.user}
                            </div>
                          </div>

                          {/* User*/}
                          <div
                            style={{
                              position: "absolute",
                              bottom: 10,
                              right: 10,
                              textAlign: "right",
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                opacity: 0.6,
                                fontWeight: "bold",
                                marginTop: 10,
                              }}
                            >
                              AGENT
                            </div>
                            <div style={{ marginTop: 3 }}>
                              {item.comment.agent}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}

                <div style={{ minHeight: 20 }} />
              </div>
            ) : null}

            {selectedView === "forms" ? (
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {display && display.taskType === "liscense" ? (
                  <>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("Lo1")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      LO1 - ABR
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("Lo4")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      LO4 - ADV
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("Lo8")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      LO8 - ALV
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("Lo9")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      LO9 - ANR
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L12")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L12 - CNV
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L13")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L13 - COO
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L14")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L14 - DCT
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L16")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L16 - DRC
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L18")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L18 - ELF1
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L21")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L21 - MIB
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L24")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L24 - MTN1
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L25")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L25 - MVR1
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L26")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L26 - MVR2
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L27")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L27 - NCO
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L28")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L28 - NCP
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L29")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L29 - NVM
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L30")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L30 - PD1
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L31")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L31 - PLN_KZN
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L34")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L34 - RLF
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L35")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L35 - RLV
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L37")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L37 - SOA
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("L38")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L38 - TSP1
                    </div>
                    <div style={{ minHeight: 20 }} />
                  </>
                ) : null}

                {display && display.taskType === "Fine" ? (
                  <>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f01")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F01 - AARTO23
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f02")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F02 - AARTO25
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f04")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F04 - AARTO30
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f05")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F05 - AARTO08+
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f06")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F06 - AARTO04
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f07")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F07 - AARTO07
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f07+")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F07 - AARTO07+
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f08")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F08 - AARTO14+
                    </div>
                    <div
                      onClick={
                        display.taskStatus !== "Approved"
                          ? null
                          : () => setPdfDisplay("f41")
                      }
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      F41 - CPA Nominate driver
                    </div>
                    {/* <div
                      onClick={() => setPdfDisplay("L39A")}
                      style={{
                        minHeight: 60,
                        backgroundColor: colors.white,
                        width: "90%",
                        marginTop: 20,
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center ",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      L39A - supply of info KZN
                    </div> */}
                    <div style={{ minHeight: 20 }} />
                  </>
                ) : null}
              </div>
            ) : null}

            {selectedView === "new Fine" ? (
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {display && display.taskType === "Fine" ? (
                  <div>fine fields</div>
                ) : null}
              </div>
            ) : null}
            {display ? (
              selectedView === "requests" &&
              display.taskStatus === "Approved" ? (
                <div
                  style={{
                    position: "fixed",
                    bottom: 10,
                    width: "56%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BaseButtons
                    label={"REQUEST INFORMATION"}
                    width={"95%"}
                    color={colors.secondaryDarkBlue}
                    borderRadius={4}
                    onClick={() => setRequestPopUp(true)}
                  />
                </div>
              ) : null
            ) : null}
            {display ? (
              selectedView === "comments" &&
              display.taskStatus === "Approved" ? (
                <div
                  style={{
                    position: "fixed",
                    bottom: 10,
                    width: "56%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BaseButtons
                    label={"ADD COMMENT"}
                    width={"95%"}
                    color={colors.secondaryDarkBlue}
                    borderRadius={4}
                    onClick={() => setCommentPopUp(true)}
                  />
                </div>
              ) : null
            ) : null}
            {display ? (
              selectedView === "timeline" &&
              display.taskStatus === "Approved" ? (
                <div
                  style={{
                    position: "fixed",
                    bottom: 10,
                    width: "56%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BaseButtons
                    label={"REQUEST PAYMENT"}
                    width={"95%"}
                    color={colors.secondaryDarkBlue}
                    borderRadius={4}
                    onClick={() => RequestTaskPayment()}
                  />
                </div>
              ) : display.taskStatus === "Payment Request" ? (
                <div
                  style={{
                    position: "fixed",
                    bottom: 10,
                    width: "56%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BaseButtons
                    label={"PAYMENT RECIEVED"}
                    width={"85%"}
                    color={colors.white}
                    borderRadius={4}
                    backgroundColor={colors.primaryBlue}
                    onClick={() => PaymentRecieved()}
                  />
                </div>
              ) : null
            ) : null}
            <div style={{ minHeight: 60 }} />
            <CommentPopup
              display={
                commentPopUp && selectedView === "comments" ? true : false
              }
              setCommentPopUp={setCommentPopUp}
              setLoading={setLoading}
              setMessage={setMessage}
              setToastPop={setToastPop}
              setPopUpTitle={setPopUpTitle}
              customerData={customerData}
              auth={auth}
              data={display}
            />
            <RequestPopUp
              display={
                requestPopUp && selectedView === "requests" ? true : false
              }
              data={display}
              setCommentPopUp={setRequestPopUp}
              setLoading={setLoading}
              setMessage={setMessage}
              setToastPop={setToastPop}
              setPopUpTitle={setPopUpTitle}
              customerData={customerData}
              auth={auth}
            />
          </div>
        )}
        {display ? (
          display.taskType === "liscense" ? (
            <>
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "Lo1" ? (
                    <L01_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "Lo4" ? (
                    <L04_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "Lo8" ? (
                    <L08_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "Lo9" ? (
                    <L09_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L12" ? (
                    <L12_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L13" ? (
                    <L13_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L14" ? (
                    <L14_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L16" ? (
                    <L16_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L18" ? (
                    <L18_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L21" ? (
                    <L21_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L24" ? (
                    <L24_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L27" ? (
                    <L27_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L26" ? (
                    <L26_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L25" ? (
                    <L25_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L28" ? (
                    <L28_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L29" ? (
                    <L29_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L30" ? (
                    <L30_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L31" ? (
                    <L31_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L34" ? (
                    <L34_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L35" ? (
                    <L35_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L37" ? (
                    <L37_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "L38" ? (
                    <L38_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
            </>
          ) : null
        ) : null}

        {display ? (
          display.taskType === "Fine" ? (
            <>
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f01" ? (
                    <F01_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f02" ? (
                    <F02_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f04" ? (
                    <F04_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f05" ? (
                    <F05_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f06" ? (
                    <F06_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f07" ? (
                    <F07_Doc1
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f07+" ? (
                    <F07_Doc2
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f08" ? (
                    <F08_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
              {display ? (
                display.taskStatus === "Approved" ? (
                  pdfDisplay === "f41" ? (
                    <F41_Doc
                      height={height}
                      pdfDisplay={pdfDisplay}
                      setPdfDisplay={setPdfDisplay}
                      setLoading={setLoading}
                      setMessage={setMessage}
                      setToastPop={setToastPop}
                      setPopUpTitle={setPopUpTitle}
                      customerData={customerData}
                      auth={auth}
                      data={display}
                      companyInformation={companyInformation}
                    />
                  ) : null
                ) : null
              ) : null}
            </>
          ) : null
        ) : null}

        {display ? (
          display.taskType === "Enatis" && selectedView === "forms" ? (
            <div
              style={{
                flex: 0.65,
                display: "flex",
                // backgroundColor: "#FFFFFF",
                // position: "absolute",
              }}
            >
              <div
                style={{
                  // backgroundColor: "#FFFFFF30",
                  marginTop: 5,
                  height: height - 145,
                  flex: 1,
                  maxWidth: width - 730,
                  width: width - 730,
                  marginLeft: 4,
                  // width: "20%",
                  // width: width - 800,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                {display.taskIdentifier === "All vehicles owned" ? (
                  <div
                    style={{
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      marginTop: 20,

                      fontSize: 20,
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: 20 }}>
                      ALL VEHICLES OWNED ENATIS REPORT
                    </div>
                    <div style={{ flex: 1 }} />
                    <BaseButtons
                      label={"+"}
                      width={40}
                      fontSize={20}
                      borderRadius={4}
                      backgroundColor={colors.primaryBlue}
                      onClick={() => setAddVehicle(true)}
                    />
                    <div style={{ minWidth: 20 }} />
                  </div>
                ) : null}

                {display.taskIdentifier === "All vehicles owned" ? (
                  addVehicle ? (
                    foundVehicle ? (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <TextInputField
                          labelTitle={"Licence Number"}
                          mini={true}
                          invert={true}
                          width={"100%"}
                          size={"93%"}
                          placeholder={"e.g GHJ656G"}
                          color={"#FFFFFF"}
                          fontWeight={"bold"}
                          fontColor={"#FFFFFF"}
                        />
                        <TextInputField
                          labelTitle={"Register Number"}
                          mini={true}
                          invert={true}
                          width={"100%"}
                          size={"93%"}
                          placeholder={"e.g GHJ656G"}
                          color={"#FFFFFF"}
                          fontWeight={"bold"}
                          fontColor={"#FFFFFF"}
                        />
                        <TextInputField
                          labelTitle={"Chassis / Vin Number"}
                          mini={true}
                          invert={true}
                          width={"100%"}
                          size={"93%"}
                          placeholder={"e.g GHJ656G"}
                          color={"#FFFFFF"}
                          fontWeight={"bold"}
                          fontColor={"#FFFFFF"}
                        />

                        <TextInputField
                          labelTitle={"Engine Number"}
                          mini={true}
                          invert={true}
                          width={"100%"}
                          size={"93%"}
                          placeholder={"e.g GHJ656G"}
                          color={"#FFFFFF"}
                          fontWeight={"bold"}
                          fontColor={"#FFFFFF"}
                        />
                        <TextInputField
                          labelTitle={"Make"}
                          mini={true}
                          invert={true}
                          width={"100%"}
                          size={"93%"}
                          placeholder={"e.g GHJ656G"}
                          color={"#FFFFFF"}
                          fontWeight={"bold"}
                          fontColor={"#FFFFFF"}
                        />
                        <TextInputField
                          labelTitle={"Series"}
                          mini={true}
                          invert={true}
                          width={"100%"}
                          size={"93%"}
                          placeholder={"e.g GHJ656G"}
                          color={"#FFFFFF"}
                          fontWeight={"bold"}
                          fontColor={"#FFFFFF"}
                        />
                        <div
                          style={{
                            width: "93%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: 20,
                          }}
                        >
                          <BaseButtons
                            label={"CANCEL"}
                            backgroundColor={colors.primaryOrange}
                            borderRadius={4}
                            width={"45%"}
                            onClick={() => {
                              setAddVehicle(false);
                              setFoundVehicle(null);
                            }}
                            fontSize={18}
                          />
                          <BaseButtons
                            label={"SUBMIT"}
                            backgroundColor={colors.primaryBlue}
                            borderRadius={4}
                            width={"45%"}
                            fontSize={18}
                            // height={40}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          marginTop: 20,

                          fontSize: 20,
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            marginLeft: 0,
                            width: "50%",
                            fontWeight: "normal",
                            textAlign: "center",
                          }}
                        >
                          SEARCH YOUR VEHICLE REGISTER NUMBER TO SEE IF THIS
                          VEHICLE ALREADY EXISTS
                        </div>
                        <TextInputField
                          labelTitle={"Register number search"}
                          mini={true}
                          invert={true}
                          width={"100%"}
                          size={250}
                          placeholder={"e.g GHJ656G"}
                        />
                        <div style={{ minHeight: 15 }} />
                        <BaseButtons
                          label={"SEARCH"}
                          width={250}
                          borderRadius={4}
                          backgroundColor={colors.primaryBlue}
                          onClick={() => setFoundVehicle("something")}
                        />
                      </div>
                    )
                  ) : (
                    <>
                      <div style={{ color: "#FFFFFF", marginTop: 20 }}>
                        here is the list of vehicles found attached to your
                        customers ID Number
                      </div>
                    </>
                  )
                ) : null}

                {display.taskIdentifier === "Person particulars" ? (
                  <div
                    style={{
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      marginTop: 20,

                      fontSize: 20,
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: 20 }}>
                      ENATIS PERSON PARTICULARS DATA
                    </div>
                    <div style={{ flex: 1 }} />

                    <div style={{ minWidth: 20 }} />
                  </div>
                ) : null}

                {display.taskIdentifier === "Person particulars" ? (
                  <>
                    <div style={{ minHeight: 20 }} />
                    <TextInputField
                      labelTitle={"Identification type"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Nationality"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Gender"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Surname"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Full Name"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Initials"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Date of Birth"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Official Language"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Telephone number at home"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Email"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Day contact number"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Facsimilie Number"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Cellphone number"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Registering Authority"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Local Authority"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Locality of Record"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Locality of Record"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Move or merge restricted"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Operator suspension type"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Suspension expiry date"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Date of change of address"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Person status change date"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Status of Person"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Verification of address particulars"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Date verified"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div
                      style={{
                        color: "#FFFFFF",
                        marginTop: 20,
                        marginBottom: 20,
                      }}
                    >
                      ADDRESS PARTICULARS
                    </div>
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Postal Address"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Street Address"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Suburb"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"City / Town"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                    <div style={{ minHeight: 10 }} />
                    <TextInputField
                      labelTitle={"Postal code"}
                      fontColor={"#FFFFFF"}
                      invert={true}
                      mini={true}
                      size={"93%"}
                      width={"100%"}
                    />
                        <div style={{ minHeight: 10 }} />
                        <BaseButtons label={""}/>
                  </>
                ) : null}
              </div>
            </div>
          ) : null
        ) : null}
        {display ? (
          display.taskType === "Vehicle valuation" &&
          selectedView === "forms" ? (
            <div
              style={{
                flex: 0.65,
                display: "flex",
                // backgroundColor: "#FFFFFF",
                // position: "absolute",
              }}
            >
              <div
                style={{
                  // backgroundColor: "#FFFFFF30",
                  marginTop: 5,
                  height: height - 145,
                  flex: 1,
                  maxWidth: width - 730,
                  width: width - 730,
                  marginLeft: 4,
                  // width: "20%",
                  // width: width - 800,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    marginTop: 20,

                    fontSize: 20,
                    width: "100%",
                  }}
                >
                  <div style={{ marginLeft: 20 }}>
                    {" "}
                    VEHICLE VALUATION REPORT
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      marginLeft: 30,
                      marginTop: 20,
                      fontWeight: "bold",
                      color: "#FFFFFF",
                    }}
                  >
                    PRICE (VALUE IN R'S)
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <TextInputField
                    // labelTitle={""}
                    mini={true}
                    width={"100%"}
                    size={"90%"}
                    invert={true}
                    placeholder={"e.g. 100 000"}
                  />
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        marginLeft: 30,
                        marginTop: 20,
                        fontWeight: "bold",
                        color: "#FFFFFF",
                      }}
                    >
                      COMMENT / EXPLANATION
                    </div>
                  </div>
                  <TextInputFieldArea
                    // labelTitle={""}
                    mini={true}
                    width={"100%"}
                    size={"90%"}
                    height={250}
                    invert={true}
                    placeholder={
                      "e.g. Vehicle was valued this way due to its status and the cracked windscreen"
                    }
                  />
                  <div style={{ minHeight: 20 }} />
                  <BaseButtons
                    label={"SUBMIT VALUATION"}
                    backgroundColor={colors.primaryBlue}
                    borderRadius={6}
                    width={"93%"}
                  />
                </div>
              </div>
            </div>
          ) : null
        ) : null}

        {display ? (
          display.taskType === "Vehicle for sale" &&
          selectedView === "forms" ? (
            <div
              style={{
                flex: 0.65,
                display: "flex",
                // backgroundColor: "#FFFFFF",
                // position: "absolute",
              }}
            >
              <div
                style={{
                  // backgroundColor: "#FFFFFF30",
                  marginTop: 5,
                  height: height - 145,
                  flex: 1,
                  maxWidth: width - 730,
                  width: width - 730,
                  marginLeft: 4,
                  // width: "20%",
                  // width: width - 800,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    marginTop: 20,

                    fontSize: 20,
                    width: "100%",
                  }}
                >
                  <div style={{ marginLeft: 20 }}> VEHICLE PURCHASE OFFER</div>
                </div>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      marginLeft: 30,
                      marginTop: 20,
                      fontWeight: "bold",
                      color: "#FFFFFF",
                    }}
                  >
                    PRICE (VALUE IN R'S)
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <TextInputField
                    // labelTitle={""}
                    mini={true}
                    width={"100%"}
                    size={"90%"}
                    invert={true}
                    placeholder={"e.g. 100 000"}
                  />
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        marginLeft: 30,
                        marginTop: 20,
                        fontWeight: "bold",
                        color: "#FFFFFF",
                      }}
                    >
                      COMMENT / EXPLANATION
                    </div>
                  </div>
                  <TextInputFieldArea
                    // labelTitle={""}
                    mini={true}
                    width={"100%"}
                    size={"90%"}
                    height={250}
                    invert={true}
                    placeholder={
                      "e.g. Vehicle was valued this way due to its status and the cracked windscreen"
                    }
                  />
                  <div style={{ minHeight: 20 }} />
                  <BaseButtons
                    label={"SUBMIT POTENTIAL PURCHASE PRICE"}
                    backgroundColor={colors.primaryBlue}
                    borderRadius={6}
                    width={"93%"}
                  />
                </div>
              </div>
            </div>
          ) : null
        ) : null}
      </div>

      <LoadingPopUp display={loading} width={"100%"} />
    </div>
  );
};

export default TaskManager;
